export default {
    setAll (state, data) {
        state.all = data
      }
};